import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { PricePerMonth } from 'pricing-pages-ui-components/price/PricePerMonth';
import { useFeatureTableSessionCache } from '../FeatureTableSessionCacheProvider';
import { LoadingPlaceHolder } from '../LoadingPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export const PriceWrapper = ({
  columnConfig
}) => {
  var _columnConfig$purchas;
  const {
    displayOptions
  } = useFeatureTableSessionCache();
  if ((displayOptions === null || displayOptions === void 0 ? void 0 : displayOptions.showPrice) === false) {
    return null;
  }
  if (columnConfig.productApiName.includes('free') || (_columnConfig$purchas = columnConfig.purchaseMotion) !== null && _columnConfig$purchas !== void 0 && _columnConfig$purchas.toString().toLowerCase().includes('seat')) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "30px",
      marginBlockEnd: "300"
    });
  }
  if (columnConfig.price === undefined) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "30px",
      marginBlockEnd: "300",
      children: /*#__PURE__*/_jsx(LoadingPlaceHolder, {
        width: 220,
        height: 30
      })
    });
  }
  if (isNaN(columnConfig.price.price) || columnConfig.price.price === null || columnConfig.price.price === 0) {
    return /*#__PURE__*/_jsx(View, {
      blockSize: "30px",
      marginBlockEnd: "300"
    });
  }
  return /*#__PURE__*/_jsx(View, {
    blockSize: "30px",
    marginBlockEnd: "300",
    children: /*#__PURE__*/_jsx(Text, {
      children: /*#__PURE__*/_jsx(PricePerMonth, {
        price: columnConfig.price.price,
        showPricePerMonthPerSeat: columnConfig.showPricePerMonthPerSeat,
        seleniumId: `feature-table-price-${columnConfig.productApiName}`,
        currencyCode: columnConfig.price.currencyCode
      })
    })
  });
};